/** @jsxImportSource @emotion/react */
"use client";

import type { Interpolation } from "@emotion/react";

import { spacing } from "../../../../../../../global/emotion";
import type {
  CarouselApi,
  UseCarouselProps,
} from "../../../../../../hooks/useCarousel";
import { useCarousel } from "../../../../../../hooks/useCarousel";
import type { CarouselProps } from "../../../../../blocks/layout/Carousel/Carousel.emotion";
import { Carousel } from "../../../../../blocks/layout/Carousel/Carousel.emotion";

const paddingBottomStyle: Interpolation = {
  paddingBottom: spacing.m,
};
const paddingTopStyle: Interpolation = {
  paddingTop: spacing.m,
};

export type SectionCarouselProps = CarouselProps & {
  size?: CarouselApi["size"];
  apiProps?: Partial<UseCarouselProps>;
};

export const SectionCarousel = ({
  children,
  size,
  apiProps,
  ...props
}: SectionCarouselProps) => {
  const carouselApi = useCarousel({ size, ...apiProps } as UseCarouselProps);

  return (
    <Carousel
      carouselApi={carouselApi}
      containerCSS={[paddingBottomStyle, paddingTopStyle]}
      {...props}
    >
      {children}
    </Carousel>
  );
};
